// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__P3FG2","file":"styles_file__mkQKG"};